import { useEffect, useState } from 'react'

import { isEmpty } from 'lodash'

import api from 'common/api'

export const useAcademicFocuses = (onFail) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(!isEmpty(data))
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!loaded && !loading) {
      setLoading(true)
      api
        .get('/api/academicfocus/keyword')
        .then((response) => {
          setLoading(false)
          setLoaded(true)
          setData(response)
        })
        .catch(() => {
          setLoading(false)
          setLoaded(true)
          if (onFail) {
            onFail()
          }
        })
    }
  }, [onFail, loaded, loading])

  return {
    loading,
    data: data,
  }
}

export default useAcademicFocuses
